import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_CITY,
  DELETE_CITY,
  GET_ALL_CITY,
  GET_ALL_CITY_LIST,
  GET_CITY_DETAILS,
  UPDATE_CITY_DETAILS,
  UPDATE_CITY_STATUS,
} from "helpers/url_helper"

export const getAllCityList = createAsyncThunk(
  GET_ALL_CITY_LIST,
  async payload => {
    const { countryId, regionId } = payload

    const response = await get(
      `${GET_ALL_CITY_LIST}/${regionId}/${countryId}`,
      payload
    )
    return response
  }
)

export const getAllCities = createAsyncThunk(GET_ALL_CITY, async payload => {
  const response = await post(GET_ALL_CITY, payload)
  return response
})

export const updateCityStatus = createAsyncThunk(
  UPDATE_CITY_STATUS,
  async payload => {
    const response = await patch(UPDATE_CITY_STATUS, payload)
    return response
  }
)

export const addCity = createAsyncThunk(ADD_CITY, async payload => {
  const response = await post(ADD_CITY, payload)
  return response
})

export const getCityDetails = createAsyncThunk(
  GET_CITY_DETAILS,
  async payload => {
    const response = await post(GET_CITY_DETAILS, payload)
    return response
  }
)

export const updateCity = createAsyncThunk(
  UPDATE_CITY_DETAILS,
  async payload => {
    const response = await put(UPDATE_CITY_DETAILS, payload)
    return response
  }
)

export const deleteCity = createAsyncThunk(DELETE_CITY, async payload => {
  const response = await del(`${DELETE_CITY}/${payload.id}`)
  return response
})
